// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2JGfG","colMaxWidth":"Table_colMaxWidth__2ArXV"};